import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Resolve a media URL returned by the backend (e.g. "/api/files/...") into an absolute URL.
export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { path, url, original_filename, content_type }
}

// Auth is carried by secure httpOnly cookies (set by the backend on login) and
// sent automatically via withCredentials. These helpers remain for call-site
// compatibility and no longer read tokens from localStorage (XSS-safe).
export function adminHeaders() {
  return {};
}

export function partnerHeaders() {
  return {};
}

// Build a WhatsApp deep link to a customer's number with a pre-filled message.
// Normalises Israeli numbers (leading 0 -> 972). Opens WhatsApp; does NOT auto-send.
export function waLink(phone, text = "") {
  const num = (phone || "").replace(/\D/g, "").replace(/^0/, "972");
  const msg = encodeURIComponent(text || "");
  return `https://wa.me/${num}${msg ? `?text=${msg}` : ""}`;
}
